import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { getTimeDialogState, State } from "../reducers";

import { setTextField, SetTextFieldAction } from "./presentation";


export interface ShowTimeDialogAction {
    readonly type: 'SHOW_TIME_DIALOG',
    readonly textFieldKey: string,
    readonly text: string,
}

export interface CloseTimeDialogAction {
    readonly type: 'CLOSE_TIME_DIALOG',
}

export interface TimeDialogTextChangedAction {
    readonly type: 'TIME_DIALOG_TEXT_CHANGED',
    readonly text: string,
}


export function showTimeDialog(textFieldKey: string, text: string): ShowTimeDialogAction {
    return {
        type: 'SHOW_TIME_DIALOG',
        textFieldKey,
        text,
    }
}

export function closeTimeDialog(): CloseTimeDialogAction {
    return {
        type: 'CLOSE_TIME_DIALOG',
    }
}

type SubmitTimeDialogActions = CloseTimeDialogAction | SetTextFieldAction;

export function submitTimeDialog(): ThunkAction<any, State, any, SubmitTimeDialogActions> {
    return async (dispatch: ThunkDispatch<State, any, SubmitTimeDialogActions>, getState: () => State): Promise<any> => {
        const state = getState();
        const { textFieldKey, text } = getTimeDialogState(state);
        dispatch(setTextField(textFieldKey, text));
        dispatch(closeTimeDialog());
    };
}

export function timeDialogTextChanged(text: string): TimeDialogTextChangedAction {
    return {
        type: 'TIME_DIALOG_TEXT_CHANGED',
        text,
    }
}



// WEBPACK FOOTER //
// ./src/actions/time-dialog.ts